import React, {useEffect, useState} from "react";
import {
    Button,
    Card,
    CardBody,
    CardFooter,
    CardHeader, Flex,
    FormControl,
    FormLabel,
    Heading, Switch,
    Box, Text, HStack, Select as ChakraSelect, Table, Thead, Tbody, Tr, Th, Td, Input, IconButton, TableContainer
} from "@chakra-ui/react";
import {FaTrash} from "react-icons/fa";
import EmojiIcon from '@atlaskit/icon/glyph/emoji';
import Select, {ActionMeta, components, DropdownIndicatorProps, OptionType} from '@atlaskit/select';
import {api as userApi} from "../api/userAPI";
import {useAppDispatch, useAppSelector} from "../stateManagement/hooks";
import {api} from "../api/boardsApi";
import {showSwal} from "../common_components/Alert";
import {updatePreferences} from "../stateManagement/userSlice";
import {DEFAULT_CATEGORY, DEFAULT_FAVORITES, FavoriteEntry, cleanFavoritesList} from "./TimeTable/WeekActions/favorites";
import {absenceBlockMessage, isAbsenceCodeBlocked} from "./TimeTable/WeekActions/absenceRestriction";
import {HOUR_STEP_DEFAULT, HOUR_STEP_OPTIONS} from "./TimeTable/WeekActions/hourPrecision";
import {HolidayNotice} from "./TimeTable/WeekActions/WeekActionsUI";
import {Preferences} from "../types";
import {HourCategories} from "./WorklogModals/hourCategories";
import {decodeHtmlEntities} from "../utils/html";

export default function PreferencesPage() {
   const preferences = useAppSelector(state => state.user.preferences)
   // Preferences start out as in-memory defaults until the backend copy loads; saving
   // before that load completes would overwrite the user's real saved preferences.
   const preferencesLoaded = useAppSelector(state => state.user.preferencesLoaded)
   const userCanManage = useAppSelector(state => state.user.user.user_can_manage)
   const [currentUnsavedPreferences, setCurrentUnsavedPreferences] = useState<Preferences>(preferences)
    const dispatch = useAppDispatch()

    useEffect(() => {
        setCurrentUnsavedPreferences(preferences)
    }, [preferences]);
    function savePreferences(){
    userApi.updatePreferences(currentUnsavedPreferences).then(value => {
        showSwal("success-message", "Preferences Saved")
            return dispatch(updatePreferences(currentUnsavedPreferences));
        }
    ).catch(reason =>         showSwal("failed", reason))
    }
    return (
<>
  <div className={"d-flex align-items-center justify-content-center"} style={{minHeight: "50vh" }}>
<Card align='center' className={""} style={{minHeight: "40vh", width: "960px", maxWidth: "95vw"}}>
  <CardHeader>
    <Heading size='md'> User Preferences</Heading>
  </CardHeader>
  <CardBody>

    <PreferencesComponent prefs={currentUnsavedPreferences} setPrefs={setCurrentUnsavedPreferences} userCanManage={userCanManage}/>
  </CardBody>
  <CardFooter>
    <Button colorScheme='blue' onClick={savePreferences} isDisabled={!preferencesLoaded} title={preferencesLoaded ? undefined : "Loading your saved preferences..."}>Save</Button>
  </CardFooter>
</Card>
</div>
</>
    )
}



const DropdownIndicator = (props: DropdownIndicatorProps<OptionType, true>) => {
  return (
    <components.DropdownIndicator {...props}>
      <EmojiIcon label="Emoji" primaryColor={"grey"} />
    </components.DropdownIndicator>
  );
};


interface PreferenceProps{
    prefs: Preferences
    setPrefs: (v: Preferences)=>void
userCanManage: boolean
}

 function  PreferencesComponent (props: PreferenceProps){
   const [selectBoxOptions, setSelectBoxOptions] = useState<OptionType[]>([])
   const [categoryOptions, setCategoryOptions] = useState<OptionType[]>([])
   const [boardOptions, setBoardOptions] = useState<OptionType[]>([{label:"<No Board>", value: "", key:""}])
    useEffect(() => {
        userApi.getAllTeams().then(value => {
            const teamList: string[] = value.data
            setSelectBoxOptions(teamList.map(value1 => {return {label: value1, value: value1}}))
        })
        api.getBoards().then(value => {

            const boardList: Record<number, string> = value.data.boards
            const newBoardOptions = Object.entries(boardList).map(value1 => {return {label: decodeHtmlEntities(value1[1]), value: value1[0]}})
            setBoardOptions(boardOptions.concat(newBoardOptions))
        })
        setCategoryOptions(HourCategories.map(value1 => {return {label: value1.label, value: value1.value}}))


    }, []);


    function changeBoard(newValue:any, actionMeta: ActionMeta<OptionType>){

        props.setPrefs({...props.prefs, defaultBoard: newValue})
    }

     function changeCategory(newValue:any, actionMeta: ActionMeta<OptionType>){

        props.setPrefs({...props.prefs, defaultCategory: newValue?.value || ""})
    }

    function addTeam(newValue: any, actionMeta: ActionMeta<OptionType>){
        let data: OptionType[] = newValue;
        const newFavouriteTeams = data.map(value => value.value as string);
        props.setPrefs({...props.prefs, favouriteTeams:newFavouriteTeams})
    }
    const currentTeams: OptionType[] = props.prefs.favouriteTeams.map(value1 => {return {label: value1, value: value1}})
    const getCategoryValueByLabel = (value: string): string => {
      const found = HourCategories.find((cat) => cat.value === value);
      console.log(value)
      console.log(found?.label)
      return found?.label as string;
    };
          return (
  <>
      <div style={{width: "250px"}}>
        <FormControl >

            {props.userCanManage && <>
    <Flex className={"mb-2"}>
            <FormLabel htmlFor='isChecked'>Show Teams:</FormLabel>
            <Switch id='isChecked' isChecked={props.prefs.showTeams} onChange={event => props.setPrefs({...props.prefs, showTeams: event.target.checked})}/>
    </Flex>

    <FormLabel htmlFor='indicators-dropdown'>Select Teams:</FormLabel>
    <Select
      inputId="indicators-dropdown"
      closeMenuOnSelect={false}
      components={{ DropdownIndicator }}
      defaultValue={currentTeams}
      isMulti
      options={selectBoxOptions}
      value={props.prefs.favouriteTeams.map(value => {return {label: value, value: value}})}
      onChange={addTeam}
    />
</>}
    <FormLabel htmlFor='board-dropdown' className={"mt-5"}>Select Default Board:</FormLabel>
    <Select
      inputId="board-dropdown"
      closeMenuOnSelect={true}
      components={{ DropdownIndicator }}
      defaultValue={[]}
value={{label: decodeHtmlEntities(props.prefs.defaultBoard.label), value: props.prefs.defaultBoard.value}}
      onChange={changeBoard}
      options={boardOptions}

    />

    <FormLabel htmlFor='cat-dropdown' className={"mt-5"}>Select Default Category:</FormLabel>
    <Select
      inputId="cat-dropdown"
      closeMenuOnSelect={true}
      components={{ DropdownIndicator }}
      defaultValue={[]}
      value={{label: getCategoryValueByLabel(props.prefs.defaultCategory), value: props.prefs.defaultCategory}}
      onChange={changeCategory}
      options={categoryOptions}

    />

    </FormControl>
          </div>
          <WeekActionsPreferencesSection prefs={props.prefs} setPrefs={props.setPrefs}/>
  </>
)}

interface DraftFavoriteRow extends FavoriteEntry {
    key: string;
}

let favoriteRowKeySeq = 0;
function nextFavoriteRowKey(): string {
    favoriteRowKeySeq += 1;
    return `fav-${favoriteRowKeySeq}`;
}

function emptyDraftFavoriteRow(defaultCategory: string): DraftFavoriteRow {
    return {jiraId: "", summary: "", category: defaultCategory || DEFAULT_CATEGORY, comment: "", key: nextFavoriteRowKey()};
}

const HOUR_STEP_LABELS: Record<string, string> = {
    "1": "1 (whole hours)",
    "0.5": "0.5 (half hours)",
    "0.25": "0.25 (quarter hours)",
    "0.1": "0.1 (1 decimal)",
    "0.01": "0.01 (2 decimals)",
    "0.001": "0.001 (3 decimals)"
};

/**
 * Week Actions (Copy Week / Edit / Clear) settings — favorite quick-entry rows
 * and hour step — consolidated here instead of a separate toolbar dialog, and
 * saved together with the rest of this page via the shared Save button, so
 * they live in backend preferences instead of per-browser localStorage.
 */
function WeekActionsPreferencesSection(props: {prefs: Preferences; setPrefs: (v: Preferences) => void}) {
    const currentUserName = useAppSelector((s) => s.user.user.name);
    const favorites = props.prefs.weekActionsFavorites || [];
    const defaultCategory = props.prefs.defaultCategory || DEFAULT_CATEGORY;
    const [rows, setRows] = useState<DraftFavoriteRow[]>(
        favorites.map((e) => ({...e, key: nextFavoriteRowKey()}))
    );
    const [blockedNotice, setBlockedNotice] = useState("");

    function commitRows(nextRows: DraftFavoriteRow[]) {
        setRows(nextRows);
        const cleaned = cleanFavoritesList(nextRows);
        const blocked = cleaned.filter((e) => isAbsenceCodeBlocked(e.jiraId, currentUserName));
        setBlockedNotice(blocked.length > 0 ? absenceBlockMessage(currentUserName) : "");
        const allowed = cleaned.filter((e) => !isAbsenceCodeBlocked(e.jiraId, currentUserName));
        props.setPrefs({...props.prefs, weekActionsFavorites: allowed});
    }

    function updateRow(key: string, field: keyof FavoriteEntry, value: string) {
        commitRows(rows.map((r) => (r.key === key ? {...r, [field]: value} : r)));
    }

    function addRow() {
        setRows((prev) => [...prev, emptyDraftFavoriteRow(defaultCategory)]);
    }

    function removeRow(key: string) {
        commitRows(rows.filter((r) => r.key !== key));
    }

    function resetToDefaults() {
        if (!window.confirm("Replace the favorites list with the default list?")) { return; }
        commitRows(DEFAULT_FAVORITES.map((e) => ({...e, category: defaultCategory, key: nextFavoriteRowKey()})));
    }

    return (
        <div style={{width: "880px", maxWidth: "100%"}} className="mt-5">
            <Heading size="sm" mb={2}>Week Actions</Heading>
            <Text fontSize="sm" color="gray.600" mb={4}>
                Favorites and hour step used by the timetable's Copy Week / Edit dialogs. Saved with the rest of this
                page and shared across your devices.
            </Text>

            <Box borderWidth="1px" borderRadius="md" p={4} mb={4} bg="gray.50">
                <Text fontWeight={600} mb={1}>Hour step</Text>
                <Text fontSize="xs" color="gray.600" mb={2}>
                    Step size for hour input. Determines the spinner step and the number of decimals kept.
                </Text>
                <HStack>
                    <Text fontSize="sm">Step:</Text>
                    <ChakraSelect
                        size="sm"
                        width="220px"
                        value={props.prefs.weekActionsHourStep || HOUR_STEP_DEFAULT}
                        onChange={(e) => props.setPrefs({...props.prefs, weekActionsHourStep: e.target.value})}
                    >
                        {HOUR_STEP_OPTIONS.map((opt) => <option key={opt} value={opt}>{HOUR_STEP_LABELS[opt]}</option>)}
                    </ChakraSelect>
                </HStack>
            </Box>

            <HolidayNotice/>

            <Text fontWeight={600} mb={2}>Favorite project codes</Text>
            <TableContainer mb={2}>
                <Table size="sm">
                    <Thead>
                        <Tr bg="gray.100">
                            <Th>JIRA ID</Th>
                            <Th>Summary</Th>
                            <Th>Comment</Th>
                            <Th>Category</Th>
                            <Th/>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {rows.map((row) => (
                            <Tr key={row.key}>
                                <Td><Input size="sm" placeholder="NBP-4" value={row.jiraId} onChange={(e) => updateRow(row.key, "jiraId", e.target.value)}/></Td>
                                <Td><Input size="sm" placeholder="Story name" value={row.summary} onChange={(e) => updateRow(row.key, "summary", e.target.value)}/></Td>
                                <Td><Input size="sm" placeholder="Comment for TimeBox" value={row.comment} onChange={(e) => updateRow(row.key, "comment", e.target.value)}/></Td>
                                <Td>
                                    <ChakraSelect size="sm" value={row.category} onChange={(e) => updateRow(row.key, "category", e.target.value)}>
                                        {HourCategories.map((cat) => <option key={cat.value} value={cat.value}>{cat.label}</option>)}
                                    </ChakraSelect>
                                </Td>
                                <Td><IconButton aria-label="Delete row" icon={<FaTrash/>} size="xs" colorScheme="red" variant="outline" onClick={() => removeRow(row.key)}/></Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </TableContainer>
            <HStack mb={3}>
                <Button size="sm" variant="outline" colorScheme="blue" onClick={addRow}>+ Add row</Button>
                <Button size="sm" variant="outline" colorScheme="gray" onClick={resetToDefaults}>Reset to defaults</Button>
            </HStack>
            {blockedNotice && <Text fontSize="sm" color="red.600" mb={2}>{blockedNotice}</Text>}
        </div>
    );
}